export default "__VITE_ASSET__DiitYJyY__"